export const parseString = (value: string, precision: number) => {
  const parsed = Number(parseFloat(value).toFixed(precision))
  return isNaN(parsed) ? 0 : parsed
}
